// @flow
/**
 * Created by Mike Chung on 2/13/18.
 */
import {connect} from "react-redux";
import type {StoreState} from "../../../reducers/combinedReducers";
import {extractCaller} from "../../QueryPage";
import type {GenericModalDispatchProps, GenericModalStateProps} from "../../../components/GenericModal";
import GenericModal from "../../../components/GenericModal";
import type {Caller} from "../../../components/QueryPage";
import {closeEBadgeButtonModalAction, eBadgeButtonAction} from "../../../actions/ebadge/creators/eBadgeButtonActionCreator";
import {changePhotoVerificationStatus} from "../../../dao/eBadgeDao";

function getIsLoadingStatus(state, registrationCode) {
    let status = state.eBadgeAction['invalidatePhoto'] && state.eBadgeAction['invalidatePhoto'][registrationCode];
    if (status) {
        return status.isLoading;
    } else {
        return false;
    }
}

type Args = {
    registrationCode: string,
    caller: Caller
}

const mapStateToProps = (state: StoreState): GenericModalStateProps => {

    const registrationCode = state.modal['invalidatePhoto'] && state.modal['invalidatePhoto'].identifier;
    const isLoading = registrationCode ? getIsLoadingStatus(state, registrationCode)
        : false;

    const args: Args = {
        registrationCode: registrationCode || '',
        caller: extractCaller(state)
    };
    return {
        open: state.modal['invalidatePhoto'] && state.modal['invalidatePhoto'].open,
        promptMsg: `Are you sure to invalidate ${registrationCode || 'Photo'}? `,
        loadingMsg: `OK. We are invalidating ${registrationCode || 'Photo'}`,
        isLoading,
        error: state.eBadgeAction['invalidatePhoto'] && state.eBadgeAction['invalidatePhoto'].error,
        primaryActionText: 'Invalidate Photo',
        primaryActionColor: "danger",
        primaryActionClassName: "light-red",
        args: args
    }
};

const mapDispatchToProps = (dispatch): GenericModalDispatchProps => {
    return {
        primaryAction: (args: Args) => {
            dispatch(eBadgeButtonAction(args.registrationCode, args.caller, "invalidatePhoto",
                async (registrationCode, caller, authToken) => {
                    return await changePhotoVerificationStatus(registrationCode, caller, authToken, "N")
                }));
        },
        closeModal: () => {
            dispatch(closeEBadgeButtonModalAction("invalidatePhoto"));
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(GenericModal);



// WEBPACK FOOTER //
// ./src/containers/ebadge/photo/InvalidateEBadgePhotoModal.js